<div class="block-shadow p-3 bg-white"
  [ngClass]="adminMode || tool.type === 'MAIN' ? 'position-relative': 'd-flex flex-column tool-height-100 align-items-center text-center justify-content-between'">
  <div [ngClass]="adminMode || tool.type === 'MAIN' ? '':'justify-content-center'"
    class="d-flex position-relative maxwidth8rem">
    <h2 class="pb-3 fw-bold">
      {{ tool.title }}
    </h2>
  </div>
  <div class="pb-2" [innerHTML]="html"></div>
  @if (tool.type === 'TOOL') {
    <a class="btn" target="_blank" [href]="tool.link"
      [ngClass]="tool.buttonType === 'PRIMARY' ? 'btn-primary': 'btn-outline-primary'">
      {{ tool.buttonTitle }}
    </a>
  }
  @if (adminMode) {
    <span class="position-absolute">
      <fa-icon ngbTooltip="Modifier" size="lg" class="me-3 cursor-pointer text-primary" icon="pen"
      (click)="edit.emit()"></fa-icon>
      @if (tool.type === 'TOOL') {
        <fa-icon ngbTooltip="Supprimer" size="lg" class="me-3 cursor-pointer text-danger"
        icon="trash-alt" (click)="delete.emit()"></fa-icon>
      }
    </span>
  }
</div>
